import React, { useState, useEffect, useCallback } from 'react' 
import { useSelector } from 'react-redux'

import { Tooltip, CircularProgress } from '@mui/material'
import Colors from 'utils/Colors'
import { get } from 'services/api'
import { Policy } from '@mui/icons-material'
import StopIcon from '@mui/icons-material/Stop'
import NotificationIcon from 'components/NotificationIcon'
import { Button, DisabledButton, LoadingContainer } from './styles'
import PauseNotificationIcon from './PauseNotificationIcon'

const ResultBox = (props) => {
  const { backgroundColor, borderColor, id, onClick, checkType } = props
  const [loading, setLoading] = useState(true)
  const [disabledForArea, setDisabledForArea] = useState(false)
  const [disabledBySuspension, setDisabledBySuspension] = useState(false)
  const [pendingReviewsNumber, setPendingReviewsNumber] = useState(0)
  const [totalPending, setTotalPending] = useState(0)
  const [totalWaitingClarification, setTotalWaitingClarification] = useState(0)
  const token = useSelector((state) => state.auth.access_token)

  const getPossibleActions = useCallback(async () => {
    setLoading(true)

    const res = await get({
      url: `/reviews?application_uuid=${id}`,
      token: token,
    })

    if (res) {
      const { bgc_reviews_summary, rfc_reviews_summary } = res
      
      const pending = bgc_reviews_summary?.pending || 0 + rfc_reviews_summary?.pending || 0
      const suspended = bgc_reviews_summary?.suspended || 0 + rfc_reviews_summary?.suspended || 0
      const waitingClarification = bgc_reviews_summary?.waiting_clarification || 0 + rfc_reviews_summary?.waiting_clarification || 0

      setTotalPending(pending)
      setTotalWaitingClarification(waitingClarification)

      if (suspended > 0) {
        setDisabledBySuspension(true)
        setPendingReviewsNumber(0)
      } else if (pending === 0) {
        setDisabledForArea(true)
        setPendingReviewsNumber(0)
      } else {
        setPendingReviewsNumber(bgc_reviews_summary.pending || rfc_reviews_summary.pending)
        setDisabledForArea(false)
      }
    }

    setLoading(false)
  }, [id, token])

  const summaryTooltipText = () => {
    const text = `Revisões pendentes de avaliação: ${totalPending}`
    const textWaitingClarification = `Das quais, estão aguardando esclarecimento: ${totalWaitingClarification}`
    return <h4>
        {text}
        <br />
        {totalWaitingClarification > 0 && textWaitingClarification }
    </h4>
  }
  useEffect(() => {
    getPossibleActions()
  }, [getPossibleActions])

  return loading ? (
    <LoadingContainer>
      <CircularProgress size="2.9rem" style={{ color: Colors.primaryColor }} />
    </LoadingContainer>
  ) : disabledForArea || disabledBySuspension ? (
    <Tooltip
      title={
        <h4>{disabledBySuspension ? 'Essa revisão foi suspensa' : 'Essa revisão deve ser realizada por outra área'}</h4>
      }
    >
      <DisabledButton id={`${id}|${checkType}`}>
        {disabledForArea ? <Policy fontSize="small" /> : <StopIcon fontSize="small" />}
        {disabledForArea ? 'Revisão necessária' : 'Revisão suspensa'}
      </DisabledButton>
    </Tooltip>
  ) : (
    <Tooltip
      arrow
      placement='left'
      title={summaryTooltipText()}
  >
      <Button id={`${id}|${checkType}`} onClick={onClick} style={{ backgroundColor, borderColor }}>
        <Policy fontSize="small" />
        Revisão necessária
        {pendingReviewsNumber ? <NotificationIcon>{pendingReviewsNumber}</NotificationIcon> : null}
        {totalWaitingClarification > 0 ? <PauseNotificationIcon topPosition={10} rightPosition={-9} /> : null}
      </Button>
    </Tooltip>
  )
}

export default ResultBox
